import { useContext } from "react";
import cx from "classnames";

import Box, { BoxProps } from "../../Box";
import styles from "./styles.module.css";
import { CardContext } from "../Context";

type CardContentProps = BoxProps & {
  fullbleed?: boolean;
  hasHeader?: boolean;
};

const CardContent = ({ className, fullbleed, hasHeader, ...props }: CardContentProps) => {
  const { size } = useContext(CardContext);
  const contentClass = cx(
    styles.content,
    fullbleed && styles.fullbleed,
    hasHeader && styles.hasHeader,
    size === "small" && styles.small,
    className
  );

  return <Box direction="column" className={contentClass} {...props} fullWidth />;
};

CardContent.displayName = "DS.Card.Content";

export default CardContent;
